var Backbone = require('backbone');
var _ = require('underscore');
var sw = require('js/lib/sw');
var productPageActionTypes = require('js/lib/actions/ProductViewPage/actionTypes');
require('js/lib/request-animation-pollyfill');

module.exports = function($){
  var defaultPageSize = 5;

  var enableArrow = function(target) {
    $(target).removeClass('disabled');
    $(target).addClass('enabled');
  };

  var disableArrow = function(target) {
    $(target).addClass('disabled');
    $(target).removeClass('enabled');
  };

  var moveToPage = function(num) {
    num = num || 1;
    var self = $(this);
    var thumbMargin = self.data('thumb-margin');
    var totalPages = self.data('total-pages');
    if (num > totalPages) {
      return;
    }

    //convert non 0 based page number to 0 based index
    var pageIndex = num - 1;
    var pageSize = self.data('page-size') || defaultPageSize;

    // Number of images per page times page index
    var left = pageIndex * -(pageSize * thumbMargin);
    self.find('#film-strip').animate({
      left: left
    }, 450);
    self.data('current-page', num);
    if (num > 1) {
      enableArrow(self.find('.slideshow-left-arrow'));
    } else if (num === 1) {
      disableArrow(self.find('.slideshow-left-arrow'));
    }

    if (num === self.data('total-pages')) {
      disableArrow(self.find('.slideshow-right-arrow'));
    } else if (num < self.data('total-pages')) {
      enableArrow(self.find('.slideshow-right-arrow'));
    }
  };

  $.fn.slideshow = function(pageSize, options) {
    var self = $(this);
    pageSize = pageSize || defaultPageSize;
    options = options || {};

    var selectedPicture = $(this).data('swProductSlideshowSelectedPicture') || 0;

    self.data('page-size', pageSize);
    self.data('selected-picture', selectedPicture);
    self.data('current-page', 1);

    var $slideshowThumb = self.find('.slideshow-thumb');
    var thumbMargin = parseInt($slideshowThumb.outerWidth(true), 10);
    self.data('thumb-margin', thumbMargin);

    var $filmStripContainer = self.find('.product-slideshow-film-strip-container');
    var pageWidth = $filmStripContainer.innerWidth();
    self.data('page-width', pageWidth);

    pageSize = Math.ceil(pageWidth / thumbMargin);
    self.data('page-size', pageSize);

    var totalPictures = self.find('.slideshow-thumb').length;
    self.data('total-pictures', totalPictures);

    var totalPages = Math.ceil(totalPictures / pageSize);
    self.data('total-pages', totalPages);

    var leftArrow = self.find('.slideshow-left-arrow');
    var rightArrow = self.find('.slideshow-right-arrow');

    disableArrow(leftArrow);
    if (totalPages > 1) {
      enableArrow(rightArrow);
    } else {
      disableArrow(rightArrow);
    }

    var lastKnownPageWidth = $filmStripContainer.outerWidth();
    var waiting = false;
    var $filmStrip = self.find('#film-strip');

    $(window).resize(
      _.debounce(function(){
        lastKnownPageWidth = $filmStripContainer.outerWidth();

        if(!waiting) {
          window.requestAnimationFrame(function(){
            waiting = false;

            self.data('page-width', lastKnownPageWidth);

            var pageIndex = self.data('current-page') - 1;
            var left = pageIndex * -(pageWidth + thumbMargin);
            $filmStrip.animate({
              left: left
            }, 450);
          });
        }

        waiting = true;
      },
      300)
    );

    leftArrow.click(function() {
      var currentPage = self.data('current-page');
      if (currentPage > 1) {
        moveToPage.call(self, currentPage - 1);
      }
    });
    rightArrow.click(function() {
      var currentPage = self.data('current-page');
      if (currentPage < self.data('total-pages')) {
        moveToPage.call(self, currentPage + 1);
      }
    });

    self.find('.slideshow-thumb').click(function() {
      self.selectThumbnail($(this).attr('data-picture-id'));
      self.selectImage($(this).attr('data-picture-id'));
    });

    var caption = self.find('#caption');
    caption.on('click', function() {
      $(this).toggleClass('show-more');
    });

    if (options.keyboardEvents) {
      $('body').on('keydown', function(e) {
        var selectedPicture = parseInt(self.data('selected-picture'), 10);
        var totalPictures = parseInt(self.data('total-pictures'), 10);

        var $target = $(e.target);
        if ($target.is('input') || $target.is('textarea')) {
          return;
        }

        if (e.keyCode === 37) {
          if (selectedPicture > 0) {
            self.selectThumbnail(selectedPicture - 1, null, options.product);
            self.selectImage(selectedPicture - 1, null, options.product);
          }

          e.preventDefault();
        }

        if (e.keyCode === 39) {
          if (selectedPicture < (totalPictures - 1)) {
            self.selectThumbnail(selectedPicture + 1, null, options.product);
            self.selectImage(selectedPicture + 1, null, options.product);
          }

          e.preventDefault();
        }
      });
    }

    self.selectThumbnail(self.data('selected-picture'));

    // TODO: refactor slideshow to contain this code:
    //

    _.extend(this, Backbone.Events);
  };

  $.fn.swSlideshowListener = function (options) {
    var $slideShow = $(this);

    if (options.product) {
      this.listenTo(options.product, 'change:currentConfigurationId', function(product, currentConfigurationId) {
        var url = options.url;

        var params = {
          configurationId : currentConfigurationId
        };

        // Empty text to display on slideshow loading
        $slideShow.swShowLoading({
          loadingText : ''
        });

        // Request new slide show fragment
        var that = this;
        $.ajax(
          url,
          {
            data: params,
            dataType: 'html',
            success: function(result){
              that.stopListening();
              var $result = $(result);
              $slideShow.swHideLoading();
              $slideShow.replaceWith($result);
              sw.trigger('sw-fragment-loaded', $result);
            },
            error: function() {
              $slideShow.swHideLoading();
            }
          }
        );

      });

      this.listenTo(sw, sw.SW_ACTION_EVENT, function(action) {
        var self = $(this);
        if (action.type === productPageActionTypes.PREVIEW_MAIN_IMAGE_SLIDESHOW) {
          // If the URL is undefined, show the previously selected image
          if (_.isUndefined(action.payload.previewImageUrl)) {
            var selectedPicture = self.data('selected-picture');
            self.selectThumbnail(selectedPicture);
            self.selectImage(selectedPicture);
            return;
          }

          self.find('#slideshow-big > img').attr('src', action.payload.previewImageUrl);
          self.find('#caption .caption-text').text(action.payload.previewImageCaption);
          if (action.payload.isShapewaysMaterialRender) {
            self.find('.product-slideshow-render-messaging').show();
          } else {
            self.find('.product-slideshow-render-messaging').hide();
          }
        }
      });
    }
  };

  $.fn.selectThumbnail = function(thumbnailIndex) {

    var $self = $(this);
    var parsedThumbnailIndex = parseInt(thumbnailIndex, 10);

    if (parsedThumbnailIndex > ($self.data('total-pictures') || 0)) {
      return;
    }

    var $thumb = $self.find('.slideshow-thumb[data-picture-id=' + parsedThumbnailIndex + ']');
    $self.find('.slideshow-thumb.selected').removeClass('selected');
    $thumb.addClass('selected');

    var currentPage = $self.data('current-page') || 1;
    var pageSize = $self.data('page-size') || defaultPageSize;

    var page = Math.ceil((parsedThumbnailIndex + 1) / pageSize) || 1;
    if (page !== currentPage) {
      moveToPage.call($self, page);
    }
  };

  $.fn.selectImage = function(num) {

    var self = $(this);
    num = parseInt(num, 10);

    if (num > self.data('total-pictures') || 0) {
      return;
    }
    self.data('selected-picture', num);

    var thumb = self.find('.slideshow-thumb[data-picture-id=' + num + ']');
    var big = self.find('.slideshow-big-ondeck[data-picture-id=' + num + ']');
    if(!big.length){
      return;
    }

    var imageHtml = big.html();
    self.find('#slideshow-big').html(imageHtml);

    var caption = self.find('#caption .caption-text');
    var newCaption = self.find('[data-caption]').attr('data-caption');
    caption.text(newCaption || '');

    var isSWRender = thumb.data('swRender');
    if(isSWRender === true) {
      var src = thumb.find('img').attr('src');
      var parts = src.split('_');
      if(parts.length > 2 && parts[2] !== '-3'){
        $('.product-slideshow-render-messaging').show();
      } else {
        $('.product-slideshow-render-messaging').hide();
      }
    } else {
      $('.product-slideshow-render-messaging').hide();
    }
  };

};
